import $axios from "../../api";

const PREFIX = "website/product";

const state = () => ({
  isLoading: false,
  isErrors: "",
  page: 1,
  selectedCategory: [
    {
      category_id: null,
      sub_category_id: null,
      unit_id: null,
    },
  ],
  productList: [],
  productDetail: "",
  isSuccess: false,
  priceProductHistoryList: [],
  productPrice: "",
  variantData: "",
  changePriceSuccess: false,
  stockLog: {
    data: [],
    total: 0,
    per_page: 10,
    current_page: 1,
    last_page: 1,
  },
  pageStock: 1,
  // P26_0039 — from /list: { ready }. ready=false until the jbl_item_map
  // table exists on this environment.
  jubelioMeta: { ready: false },
  productVariant: [
    {
      id: 1,
      label: "Basic Variant",
    },
    {
      id: 2,
      label: "Bundle Variant",
    },
    {
      id: 3,
      label: "ED Variant",
    },
    {
      id: 4,
      label: "Buy Get Variant",
    },
    {
      id: 5,
      label: "Free Item Variant",
    },
    {
      id: 6,
      label: "Big Discount Variant",
    },
    {
      id: 7,
      label: "PWP (Purchase With Purchase) Variant",
    },
    {
      id: 8,
      label: "e-Giftcard",
    },
  ],
});

const mutations = {
  SET_LOADING(state, payload) {
    state.isLoading = payload;
  },
  ASSIGN_ERRORS(state, payload) {
    state.isErrors = payload;
  },
  SET_PAGE(state, payload) {
    state.page = payload;
  },
  ASSIGN_PRODUCT_LIST(state, payload) {
    state.productList = payload;
  },
  SET_SELECTED_CATEGORY(state, payload) {
    state.selectedCategory = payload;
  },
  SET_IS_SUCCESS(state, payload) {
    state.isSuccess = payload;
  },
  SET_PRICE_IS_SUCCESS(state, payload) {
    state.changePriceSuccess = payload;
  },
  ASSIGN_PRODUCT_DETAIL(state, payload) {
    state.productDetail = payload;
  },
  ASSIGN_PRICE_PRODUCT_HISTORY_LIST(state, payload) {
    state.priceProductHistoryList = payload;
  },
  ASSIGN_PRODUCT_PRICE(state, payload) {
    state.productPrice = payload;
  },
  ASSIGN_VARIANT_DATA(state, payload) {
    state.variantData = payload;
  },
  SET_STOCK_LOG(state, payload) {
    state.stockLog = payload;
  },
  SET_PAGE_STOCK(state, payload) {
    state.pageStock = payload;
  },
  ASSIGN_JUBELIO_META(state, payload) {
    state.jubelioMeta = payload || { ready: false };
  },
};

const actions = {
  getAllProduct({ commit, state, rootState, dispatch }, payload) {
    commit("SET_LOADING", true);
    return new Promise((resolve, reject) => {
      $axios
        .get(`${PREFIX}/list?view=${rootState.Main.view}&page=${state.page}${payload ? payload : ""}`)
        .then((res) => {
          commit("ASSIGN_PRODUCT_LIST", res.data.data);
          commit("ASSIGN_JUBELIO_META", res.data.jubelio);
          commit("SET_LOADING", false);
        })
        .catch((error) => {
          commit("SET_LOADING", false);
          dispatch("Main/globalSweetAlert", error.response, {
            root: true,
          });
        });
    });
  },
  getProduct({ commit, state, rootState, dispatch }, payload) {
    commit("SET_LOADING", true);
    return new Promise((resolve, reject) => {
      $axios
        .get(`${PREFIX}/listvariant${payload ? payload : ""}`)
        .then((res) => {
          commit("ASSIGN_PRODUCT_LIST", res.data.data);
          commit("SET_LOADING", false);
        })
        .catch((error) => {
          commit("SET_LOADING", false);
          dispatch("Main/globalSweetAlert", error.response, {
            root: true,
          });
        });
    });
  },
  createProductVariant({ commit, state, rootState, dispatch }, payload) {
    commit("SET_IS_SUCCESS", false);
    commit("SET_LOADING", true);
    return new Promise((resolve, reject) => {
      $axios
        .post(`${PREFIX}/create`, payload)
        .then((res) => {
          commit("SET_IS_SUCCESS", true);
          commit("SET_LOADING", false);
        })
        .catch((error) => {
          commit("ASSIGN_ERRORS", error.response.data.errors);
          commit("SET_IS_SUCCESS", false);
          commit("SET_LOADING", false);
          dispatch("Main/globalSweetAlert", error.response, {
            root: true,
          });
        });
    });
  },
  createVariant({ commit, state, rootState, dispatch }, payload) {
    commit("SET_IS_SUCCESS", false);
    commit("SET_LOADING", true);
    if (payload?.tag?.length && Array.isArray(payload.tag)) {
      payload.tag = payload.tag.join(",");
    }
    return new Promise((resolve, reject) => {
      $axios
        .post(`${PREFIX}/variant/create`, payload)
        .then((res) => {
          commit("SET_IS_SUCCESS", true);
          commit("SET_LOADING", false);
        })
        .catch((error) => {
          // Clear loading FIRST so the CK4 editors (bound :read-only="isLoading")
          // always unlock — even on a no-response failure where error.response is
          // undefined. Reading .data.errors must be null-safe or it throws here.
          commit("SET_LOADING", false);
          commit("SET_IS_SUCCESS", false);
          commit("ASSIGN_ERRORS", error?.response?.data?.errors ?? "");
          dispatch("Main/globalSweetAlert", error.response, {
            root: true,
          });
        });
    });
  },
  hideShowVariant({ commit, state, rootState, dispatch }, payload) {
    commit("SET_IS_SUCCESS", false);
    commit("SET_LOADING", true);
    return new Promise((resolve, reject) => {
      $axios
        .post(`${PREFIX}/variant/showhide`, payload)
        .then((res) => {
          commit("SET_IS_SUCCESS", true);
          commit("SET_LOADING", false);
        })
        .catch((error) => {
          commit("SET_IS_SUCCESS", false);
          commit("SET_LOADING", false);
          dispatch("Main/globalSweetAlert", error.response, {
            root: true,
          });
        });
    });
  },
  hideShowProduct({ commit, state, rootState, dispatch }, payload) {
    commit("SET_IS_SUCCESS", false);
    commit("SET_LOADING", true);
    return new Promise((resolve, reject) => {
      $axios
        .post(`${PREFIX}/showhide`, payload)
        .then((res) => {
          commit("SET_IS_SUCCESS", true);
          commit("SET_LOADING", false);
        })
        .catch((error) => {
          commit("SET_IS_SUCCESS", false);
          commit("SET_LOADING", false);
          dispatch("Main/globalSweetAlert", error.response, {
            root: true,
          });
        });
    });
  },
  getProductData({ commit, state, rootState, dispatch }, payload) {
    commit("SET_LOADING", true);
    return new Promise((resolve, reject) => {
      $axios
        .get(`${PREFIX}/view?id=${payload ? payload : ""}`)
        .then((res) => {
          commit("ASSIGN_PRODUCT_DETAIL", res.data.data);
          commit("SET_LOADING", false);
        })
        .catch((error) => {
          commit("SET_LOADING", false);
          dispatch("Main/globalSweetAlert", error.response, {
            root: true,
          });
        });
    });
  },
  updateProduct({ commit, state, rootState, dispatch }, payload) {
    commit("SET_IS_SUCCESS", false);
    commit("SET_LOADING", true);
    return new Promise((resolve, reject) => {
      $axios
        .post(`${PREFIX}/update`, payload)
        .then((res) => {
          commit("SET_IS_SUCCESS", true);
          commit("SET_LOADING", false);
        })
        .catch((error) => {
          commit("ASSIGN_ERRORS", error.response.data.errors);
          commit("SET_IS_SUCCESS", false);
          commit("SET_LOADING", false);
          dispatch("Main/globalSweetAlert", error.response, {
            root: true,
          });
        });
    });
  },
  moveProduct({ commit, state, rootState, dispatch }, payload) {
    commit("SET_IS_SUCCESS", false);
    commit("SET_LOADING", true);
    return new Promise((resolve, reject) => {
      $axios
        .post(`${PREFIX}/variant/move`, payload)
        .then((res) => {
          commit("SET_LOADING", false);
          commit("SET_IS_SUCCESS", true);
        })
        .catch((error) => {
          commit("ASSIGN_ERRORS", error.response.data.errors);
          commit("SET_IS_SUCCESS", false);
          commit("SET_LOADING", false);
          dispatch("Main/globalSweetAlert", error.response, {
            root: true,
          });
        });
    });
  },
  addSkuSap({ commit, state, rootState, dispatch }, payload) {
    commit("SET_IS_SUCCESS", false);
    commit("SET_LOADING", true);
    return new Promise((resolve, reject) => {
      $axios
        .post(`${PREFIX}/variant/insert-sku-sap`, payload)
        .then((res) => {
          commit("SET_LOADING", false);
          commit("SET_IS_SUCCESS", true);
        })
        .catch((error) => {
          commit("ASSIGN_ERRORS", error.response.data.errors);
          commit("SET_IS_SUCCESS", false);
          commit("SET_LOADING", false);
          dispatch("Main/globalSweetAlert", error.response, {
            root: true,
          });
        });
    });
  },
  // P26_0039 — Jubelio pairing modal. These resolve/reject (unlike the older
  // actions) so the modal can show Jubelio's own error inline: a 503 "Jubelio
  // tidak bisa dihubungi" would otherwise land in globalSweetAlert's generic
  // branch and render as "[object Object]".
  searchJubelio(_ctx, { q, sku }) {
    const params = new URLSearchParams({ q, sku: sku || "" });
    return $axios
      .get(`${PREFIX}/variant/jubelio/search?${params.toString()}`)
      .then((res) => res.data.data);
  },
  pairJubelio(_ctx, payload) {
    // `warning`: before the cutover a SKU with open orders is paired, with their count (QA e4f3ac03).
    return $axios
      .post(`${PREFIX}/variant/jubelio/pair`, payload)
      .then((res) => ({ ...(res.data.data || {}), warning: res.data.warning || null }));
  },
  unpairJubelio(_ctx, payload) {
    return $axios
      .post(`${PREFIX}/variant/jubelio/unpair`, payload)
      .then((res) => res.data.data);
  },
  getVariantData({ commit, state, rootState, dispatch }, payload) {
    commit("SET_LOADING", true);
    return new Promise((resolve, reject) => {
      $axios
        .get(`${PREFIX}/variant/view?id=${payload ? payload : ""}`)
        .then((res) => {
          commit("ASSIGN_VARIANT_DATA", res.data.data);
          commit("SET_LOADING", false);
        })
        .catch((error) => {
          commit("SET_LOADING", false);
          dispatch("Main/globalSweetAlert", error.response, {
            root: true,
          });
        });
    });
  },
  variantUpdate({ commit, state, rootState, dispatch }, payload) {
    commit("SET_IS_SUCCESS", false);
    commit("SET_LOADING", true);
    if (payload?.tag?.length && Array.isArray(payload.tag)) {
      payload.tag = payload.tag.join(",");
    }
    return new Promise((resolve, reject) => {
      $axios
        .post(`${PREFIX}/variant/update`, payload)
        .then((res) => {
          commit("SET_LOADING", false);
          commit("SET_IS_SUCCESS", true);
        })
        .catch((error) => {
          // Clear loading FIRST so the CK4 editors (bound :read-only="isLoading")
          // always unlock — even on a no-response failure (timeout / empty-body
          // 5xx) where error.response is undefined. Reading .data.errors must be
          // null-safe or it throws here and leaves the page frozen.
          commit("SET_LOADING", false);
          commit("SET_IS_SUCCESS", false);
          commit("ASSIGN_ERRORS", error?.response?.data?.errors ?? "");
          dispatch("Main/globalSweetAlert", error.response, {
            root: true,
          });
        });
    });
  },
  adjStock({ commit, state, rootState, dispatch }, payload) {
    commit("SET_IS_SUCCESS", false);
    commit("SET_LOADING", true);
    commit("ASSIGN_ERRORS", "");

    return new Promise((resolve, reject) => {
      $axios
        .post(`${PREFIX}/stock/adjust`, payload)
        .then((response) => {
          commit("SET_LOADING", false);

          const res = response.data;

          if (res.status === "success") {
            commit("SET_IS_SUCCESS", true);
            resolve(res);

          } else {
            dispatch(
              "Main/globalSweetAlert",
              {
                status: "failed",
                message: res.message,
              },
              { root: true }
            );
            reject(res);
          }
        })
        .catch((error) => {
          commit("SET_LOADING", false);
          commit("SET_IS_SUCCESS", false);

          if (error.response && error.response.status === 422) {
            commit("ASSIGN_ERRORS", error.response.data.errors);
          }

          dispatch("Main/globalSweetAlert", error.response, { root: true });

          reject(error);
        });
    });
  },
  getStockLog({ commit, state, rootState, dispatch }, product_detail_id) {
    commit("SET_LOADING", true);

    return new Promise((resolve, reject) => {
      $axios
        .get(`${PREFIX}/stock/log/${product_detail_id}`, { params: { page: state.pageStock } })
        .then((res) => {
          commit("SET_STOCK_LOG", res.data.data.log_stock);
          commit("SET_LOADING", false);
          resolve(res.data.data);
        })
        .catch((error) => {
          commit("SET_LOADING", false);
          dispatch("Main/globalSweetAlert", error.response, { root: true });
          reject(error);
        });
    });
  },
  importStockExcel({ commit }, file) {
    commit("SET_LOAD_UPLOAD_EXCEL", true);
    commit("SET_UPLOAD_ERROR", null);
    commit("SET_STOCK_MESSAGE", null);

    const formData = new FormData();
    formData.append("file", file);

    return new Promise((resolve, reject) => {
      $axios
        .post("website/product/stock/import", formData)
        .then((res) => {
          commit("SET_LOAD_UPLOAD_EXCEL", false);
          commit("SET_STOCK_MESSAGE", res.data.failed_to_update);
          resolve(res.data);
        })
        .catch((err) => {
          commit("SET_LOAD_UPLOAD_EXCEL", false);
          commit("SET_UPLOAD_ERROR", err.response.data.errors);
          reject(err);
        });
    });
  }


};

export default {
  namespaced: true,
  state,
  actions,
  mutations,
};
